import { Component, inject, Signal, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { LayoutService } from '../layout.service';
import { AuthService } from '../../services/auth.service';
import { ModuleService } from '../../services/module.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule, NgIf, AsyncPipe],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
    private layoutService = inject(LayoutService);
    private authService = inject(AuthService);
    private moduleService = inject(ModuleService);

    isCollapsed: Signal<boolean> = this.layoutService.isSidebarCollapsed;
    disableTransitions = signal(true);

    // Observable stream for menu visibility
    menuState$: Observable<any>;

    constructor() {
        this.menuState$ = this.moduleService.permissions$.pipe(
            map(() => ({
                reports: this.moduleService.canAccess('reports'),
                users: this.moduleService.canAccess('users'),
                projects: this.moduleService.canAccess('projects'),
                analysis: this.moduleService.canAccess('analysis'),
                timelogs: this.moduleService.canAccess('timelogs'),
                profile: this.moduleService.canAccess('profile'),
                financeReport: this.authService.getUserRole() === 'Finance' || this.authService.getUserRole() === 'SystemAdmin' || this.authService.getUserRole() === 'Admin',
                isSystemAdmin: this.authService.getUserRole() === 'SystemAdmin',
                canManageSettings: this.authService.getUserRole() === 'SystemAdmin' || this.authService.getUserRole() === 'Admin'
            }))
        );
    }

    ngOnInit() {
        // Prevent initial transition
        setTimeout(() => {
            this.disableTransitions.set(false);
        }, 300); // 300ms matches CSS transition duration
    }

    toggleSidebar() {
        this.layoutService.toggleSidebar();
    }

    logout() {
        this.authService.logout();
    }

    onNavLinkClick() {
        if (window.innerWidth <= 768) {
            this.layoutService.isSidebarCollapsed.set(true);
        }
    }
}
